import { Box, CircularProgress } from "@material-ui/core";
import React from "react";

export default function Notes() {
    return (
        <Box mt={2}>
            <CircularProgress color={"primary"} size={30} />
        </Box>
    );
}
